import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import { Record } from 'src/app/features/Availability/days-off-config/models/List.Days';
import Swal from 'sweetalert2';
import { UnavailableDayService } from '../services/dayOff.service';
import { RestaurantDetails } from 'src/app/features/restaurants/models/List.Restaurant';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
export interface DialogData {
  record: Record
}
@Component({
  selector: 'app-days-off-form',
  templateUrl: './days-off-form.component.html'
})
export class DaysOffFormComponent extends DirtyComponent implements OnInit {

  override formGroup!: FormGroup;
  dataLoading = false;
  loading = false;
  restaurantloading = false;
  isSubmitted = false;

  severalDays: boolean = true;

  isUpdate: boolean = this.data.record ? true : false;
  details!: Record;

  branchesList: any[] = [];
  disableButton = false;
  allRestaurants: RestaurantDetails[] = [];

  isSelected = false;
  endDateMinValue: any;
  constructor(override dialogRef: MatDialogRef<DaysOffFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder,
    translate: TranslateService, private service: UnavailableDayService,
    private restaurantService: RestaurantService,
    private cdr: ChangeDetectorRef) {
    super(translate)
  }

  ngOnInit(): void {
    this.buildForm();
    this.GetRestaurants()
    if (this.isUpdate) {
      this.GetDetails();
    }

  }
  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
  GetDetails() {
    this.dataLoading = true;
    this.service.GetDetails(this.data.record.id).subscribe((data: Record) => {
      this.details = data;
      this.severalDays = this.details.severalDays;
      this.dataLoading = false;
      this.bindDataToUpdate();
    })
  }

  GetRestaurants() {
    this.restaurantloading = true;
    this.restaurantService.GetOwneRestaurant().subscribe((data: any) => {
      this.restaurantloading = false;
      this.allRestaurants = data.pageData;
    })
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      title_EN: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(255),
        // Validators.pattern(Patterns.enTxtWithSpecial),
        Validators.required
      ]],
      title_AR: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(255),
        // Validators.pattern(Patterns.arTxtWithSpecial),
        Validators.required
      ]],
      recurringYear: [],
      startDate: [null, Validators.required],
      endDate: [null],
      branches: new FormControl([], Validators.required),
      saveAnyWay: [false]
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
  override canDeactivate(): boolean {
    return this.formGroup.dirty;
  };

  bindDataToUpdate() {
    this.formGroup.patchValue({
      title_EN: this.details.title_EN,
      title_AR: this.details.title_AR,
      recurringYear: this.details.recurringYear,
      // startDate: this.details.startDate.gregorianDate,
      // endDate: this.details.endDate.gregorianDate,
      branches: this.details.branches,
    });
    this.formGroup.controls['startDate'].setValue(this.details.startDate.gregorian);
    this.formGroup.controls['endDate'].setValue(this.details.endDate?.gregorian);
    if (this.details.branches.length === this.allRestaurants?.length) {
      this.isSelected = true;
    }
  }

  changeStartDate() {
    if (this.formGroup.controls['startDate'].value !== this.details?.startDate.gregorian){
      this.formGroup.controls['endDate'].setValue(null);
    }
   
    this.endDateMinValue = {
      day: this.formGroup.controls['startDate'].value.day + 1,
      isHijri: this.formGroup.controls['startDate'].value.isHijri,
      month: this.formGroup.controls['startDate'].value.month,
      year: this.formGroup.controls['startDate'].value.year
    }
  }
  selectAllBranches() {
    if (this.isSelected) {
      this.formGroup.controls['branches'].reset()
      this.isSelected = false;
    }
    else {
      this.formGroup.controls['branches'].setValue(
        this.allRestaurants.map(x => x.id)
      )
      this.isSelected = true;
    }
  }


  saveRecord(saveAnyWay: boolean = false) {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;

      let data: any;
      data = {
        title_EN: this.formGroup.controls['title_EN'].value,
        title_AR: this.formGroup.controls['title_AR'].value,
        recurringYear: this.formGroup.controls['recurringYear'].value ? true : false,
        startDate: this.formGroup.controls['startDate'].value,
        endDate: this.severalDays ? this.formGroup.controls['endDate'].value : null,
        branches: this.formGroup.controls['branches'].value,
        saveAnyWay
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.id = this.data.record.id;
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.saveRecord(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        if (error.status == 400) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Areyousure'),
            text: error.detail,
            icon: 'info',
            showCancelButton: true,
            cancelButtonText: this.translate.instant('swalMsg.NoCancel'),
            confirmButtonText: this.translate.instant('swalMsg.saveAnyWay'),
          }).then((res) => {
            if (res.value) {
              this.saveRecord(true);
            }
          });
        } else {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.Ok'),
          });
        }
      });
    }
  }
}
